// @flow
import React, { useEffect, useState, useCallback, useMemo } from 'react'
import * as DmsCommon from './../supports/dms-common';
import * as DmsService from './../supports/dms-service';
import { styled } from '@mui/material/styles';
import { GlobalEvent, GlobalState } from './GlobalContext'
import MsgDialog from './MsgDialog';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import CircularProgress from '@mui/material/CircularProgress';
// import useImage from 'use-image';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import Checkbox from '@mui/material/Checkbox';
import FormGroup from '@mui/material/FormGroup';
import Backdrop from '@mui/material/Backdrop';
import { useForm, Controller } from "react-hook-form";
import SaveIcon from '@mui/icons-material/Save';
import Box from '@mui/material/Box';


let LINKED_FOLDER_RAG_IMG = "images/ai-folder-24.png";

export default function FolderAddDialog(props) {

  const {
    sysID, open, onClose, afterUpdate, editMode,
    folderID, createFromFolderID, folderParentID,
    folderName, mobileAccessible, internetAccess, ragEnabled, isMonitorFolder } = props;

  // Get Global state and dispatcher
  const [gState, gStateDispatch] = React.useContext(GlobalState);

  const [gEvent, gEventDispatch] = React.useContext(GlobalEvent);

  const [showLoading, setShowLoading] = useState(false);
  const [showError, setShowError] = useState(false);
  const [errMsg, setErrMsg] = useState("");

  const allowRAG = ["DMS_DE", "DMS_IT"].includes(sysID);

  const onCatchPromiseError = (e) => {
    gEventDispatch({
      showErr: true,
      err: e,
    });

  }

  const handleCloseClick = () => {
    // initData();

    onClose && onClose();
  }

  // const initData = () => {
  //   setValue("folderName", "")
  // }

  // Setup inital form values
  const defaultFormValues = {
    folderName: "",
    mobileAccessible: false,
    internetAccess: false,
    ragEnabled: false,
  }

  // React Hook the form
  const { control, handleSubmit, setValue, watch } = useForm({
    defaultValues: defaultFormValues
  });

  // Use when "open" changed
  useEffect(() => {
    // console.log("useEffect DocTypeEditDialog(open)");
    if (open) {
      if (editMode) {
        setValue("folderName", folderName);
        setValue("mobileAccessible", mobileAccessible);
        setValue("internetAccess", internetAccess || false);
        setValue("ragEnabled", ragEnabled);
      } else {
        setValue("folderName", "");
        setValue("mobileAccessible", false);
        setValue("internetAccess", false);
        setValue("ragEnabled", ragEnabled);
      }


    }

  }, [open])

  const watchDesc = watch("folderName");

  const onSubmit = async data => {
    // console.log("onSubmit", data);
    // console.log("createFromFolderID", createFromFolderID);

    if (editMode) {
      setShowLoading(true);
      try {
        await DmsService.folderUpdatePromise(gState.sessionID, sysID, folderID,
          data.folderName, data.mobileAccessible, data.ragEnabled, data.internetAccess);

        setShowLoading(false);

        afterUpdate && afterUpdate(folderID, data.folderName, data.mobileAccessible, data.ragEnabled, data.internetAccess);

      } catch (e) {
        setShowLoading(false);

        onCatchPromiseError(e);

      }
    } else {
      setShowLoading(true);

      try {
        const [vNewFolderID, vFolderExists] = await DmsService.folderAddPromise(
          gState.sessionID, sysID, data.folderName, createFromFolderID, "", data.mobileAccessible, data.ragEnabled, data.internetAccess
        );


        setShowLoading(false);

        afterUpdate && afterUpdate(vNewFolderID, data.folderName, data.mobileAccessible, data.ragEnabled, data.internetAccess);

      } catch (e) {
        setShowLoading(false);

        onCatchPromiseError(e);

      }


    }


  }

  let showMobileAccessible = false;

  if (editMode) {
    showMobileAccessible = (folderParentID === DmsCommon.ALL_FOLDER_ID ||
      folderParentID === DmsCommon.PERSONAL_FOLDER_ID)
  } else {
    showMobileAccessible = (createFromFolderID === DmsCommon.ALL_FOLDER_ID ||
      createFromFolderID === DmsCommon.PERSONAL_FOLDER_ID)
  }


  return (
    <Dialog
      open={open}
      maxWidth={"md"}
      aria-describedby="folder-add-dialog-description"
    >
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <MsgDialog
        open={showError}
        title="Error"
        msgText={errMsg}
        onClose={() => setShowError(false)}
      />

      <DialogTitle id="alert-dialog-title">
        {editMode && "Edit Folder"}
        {!editMode && "Add Folder"}
      </DialogTitle>
      <DialogContent>

        <Box sx={{ display: 'flex', flexDirection: 'column' }} component="form" onSubmit={handleSubmit(onSubmit)} >
          <Controller
            name="folderName"
            control={control}
            render={({ field }) =>

              <TextField
                label="Folder Name"
                autoFocus
                disabled={isMonitorFolder}
                sx={{ m: 1, width: "300px" }}
                {...field}
                InputLabelProps={{ shrink: true, }}
              />

            }
          />

          {showMobileAccessible &&

            <Controller
              name="mobileAccessible"
              control={control}
              render={({ field }) =>
                <FormControl component="fieldset">
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Checkbox
                          {...field}
                          checked={field.value}
                          onChange={(e) => field.onChange(e.target.checked)}
                        />}
                      label="Mobile Accessible *"
                      {...field}
                    />
                  </FormGroup>
                </FormControl>
              }
            />
          }

          {isMonitorFolder &&
            <Controller
              name="internetAccess"
              control={control}
              render={({ field }) =>
                <FormControl component="fieldset">
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Checkbox
                          {...field}
                          checked={field.value}
                          onChange={(e) => field.onChange(e.target.checked)}
                        />}
                      label="Internet Accessible"
                      {...field}
                    />
                  </FormGroup>
                </FormControl>
              }
            />
          }

          {allowRAG &&
            <Controller
              name="ragEnabled"
              control={control}
              render={({ field }) =>
                <FormControl component="fieldset">
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Checkbox
                          {...field}
                          checked={field.value}
                          onChange={(e) => field.onChange(e.target.checked)}
                        />}
                      label={
                        <Box
                          sx={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: 0.5,
                          }}
                        >
                          <span>RAG</span>
                          <Box
                            component="img"
                            src={LINKED_FOLDER_RAG_IMG}
                            alt="RAG"
                            sx={{
                              width: 18,
                              height: 18,
                              objectFit: "contain",
                            }}
                          />
                        </Box>
                      }
                      {...field}
                    />
                  </FormGroup>
                </FormControl>
              }
            />
          }


          <Box sx={{ textAlign: 'right', mt: 1 }} >

            <Button onClick={handleCloseClick}>Cancel</Button>
            <Button type="submit" variant="contained" startIcon={<SaveIcon />} disabled={(!watchDesc || watchDesc.trim() == "")}  >
              Save
            </Button>
          </Box>

        </Box>
      </DialogContent>
      <DialogActions>

      </DialogActions>
    </Dialog>

  );
}

FolderAddDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  sysID: PropTypes.string,
  afterUpdate: PropTypes.func,
  editMode: PropTypes.bool,
  folderID: PropTypes.number,
  createFromFolderID: PropTypes.number,
  folderParentID: PropTypes.number,
  folderName: PropTypes.string,
  mobileAccessible: PropTypes.bool,
  internetAccess: PropTypes.bool,
  ragEnabled: PropTypes.bool,
  isMonitorFolder: PropTypes.bool,
};
